import { Link } from "wouter"
import { AlertCircle } from "lucide-react"

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-4">
      <div className="bg-card border rounded-2xl shadow-sm p-8 text-center max-w-sm w-full">
        <div className="flex justify-center mb-6">
          <div className="bg-destructive/10 p-3 rounded-full">
            <AlertCircle className="w-8 h-8 text-destructive" />
          </div>
        </div>
        
        <h1 className="text-2xl font-serif font-bold text-foreground mb-2">
          Lost in thought
        </h1>
        <p className="text-muted-foreground text-sm mb-6">
          We couldn't find the page you're looking for. It might have been moved or deleted.
        </p>
        
        <Link 
          href="/" 
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 h-9 px-4 py-2 w-full"
        >
          Return Home
        </Link>
      </div>
    </div>
  )
}